import {
    USER_STROLLER_CONNECTION_CREATE_FAILURE,
    USER_STROLLER_CONNECTION_CREATE_REQUEST,
    USER_STROLLER_CONNECTION_CREATE_SUCCESS,
    USER_STROLLER_CONNECTION_REMOVE_SUCCESS,
    USER_STROLLERS_FETCH_FAILURE,
    USER_STROLLERS_FETCH_REQUEST,
    USER_STROLLERS_FETCH_SUCCESS,
    UserStrollerConnectionCreateFailureAction,
    UserStrollerConnectionCreateRequestAction,
    UserStrollerConnectionCreateSuccessAction,
    UserStrollerConnectionRemoveFailureAction,
    UserStrollerConnectionRemoveRequestAction,
    UserStrollerConnectionRemoveSuccessAction,
    UserStrollersFetchFailureAction,
    UserStrollersFetchRequestAction,
    UserStrollersFetchSuccessAction,
} from 'mk2/apps/blogs/containers/UserStrollersWidget/UserStrollersWidget.actions';
import { tupdate } from 'mk2/helpers/types';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

export interface UserStrollersState {
    strollersIds: number[];
    reviewIds: number[];
    loadingState: LoadingState;
    renderBlankInit: boolean;
    errorMessage: string;
}

const initialUserStrollersState: UserStrollersState = {
    strollersIds: [],
    reviewIds: [],
    loadingState: LoadingState.INIT,
    renderBlankInit: true,
    errorMessage: null,
};

declare type UserStrollersReducerAction =
    UserStrollerConnectionCreateRequestAction
    | UserStrollerConnectionCreateSuccessAction
    | UserStrollerConnectionCreateFailureAction
    | UserStrollerConnectionRemoveRequestAction
    | UserStrollerConnectionRemoveFailureAction
    | UserStrollerConnectionRemoveSuccessAction
    | UserStrollersFetchRequestAction
    | UserStrollersFetchSuccessAction
    | UserStrollersFetchFailureAction
    ;

export const userStrollersReducer: Reducer<UserStrollersState> = (state = initialUserStrollersState, action: UserStrollersReducerAction) => {
    switch (action.type) {
        case USER_STROLLERS_FETCH_REQUEST:
        case USER_STROLLERS_FETCH_FAILURE:
        case USER_STROLLER_CONNECTION_CREATE_REQUEST:
        case USER_STROLLER_CONNECTION_CREATE_FAILURE:
            return tupdate(state, {
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
            });

        case USER_STROLLER_CONNECTION_CREATE_SUCCESS:
            return tupdate(state, {
                strollersIds: [...state.strollersIds, action.response.result.stroller],
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(state.errorMessage, action),
            });

        case USER_STROLLER_CONNECTION_REMOVE_SUCCESS:
            return tupdate(state, {
                strollersIds: [
                    ...state.strollersIds.filter((i) => i !== action.strollerId),
                ],
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(state.errorMessage, action),
            });

        case USER_STROLLERS_FETCH_SUCCESS:
            return tupdate(state, {
                strollersIds: action.response.result.strollers,
                reviewIds: action.response.result.reviews,
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(state.errorMessage, action),
                renderBlankInit: false,
            });

        default:
            return state;
    }
};
